import styled from "styled-components";

export const LoginButton = styled.div`
  min-width: 60px;
  width: 60px;
  height: 60px;
  padding: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.secondary[900]};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${({ theme }) => theme.boxShadow};
  position: relative;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${({ theme }) => theme.colors.shades[0]};
    }
  }
`;

export const DrawerContainer = styled.div`
  padding: ${({ theme }) => theme.spacing * 4}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 4}px;
`;

export const UserContainer = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-column-gap: ${({ theme }) => theme.spacing * 3}px;
  align-items: center;
`;
